import { Card, Col, CardHeader, Container, Row, Alert } from "reactstrap";
import { H5, H2 } from "../../../AbstractElements";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";
import { useEffect, useState } from "react";
import useFourListe from "../../Fournisseurs/FourApi";
import FormulairesAutresBons from "./formulaire";

const NouveauAutresBon = () => {

    const [selectType, setSelectType] = useState('')
    const [idFournisseur, setIdFournisseur] = useState<number>()
    const [refresh, setRefresh] = useState(false)
    const fournisseur = useFourListe(refresh)

    const selectFournisseur = ({ id, type }: { id: number, type: string }) => {
        setSelectType(type);
        setIdFournisseur(id);
    }

    useEffect(() => {

    }, [idFournisseur, selectType])

    return (
        <div className='page-body'>
            <Breadcrumbs mainTitle="Autres Nouveau Bons" parent="Gestions" />
            <Container fluid>

                {
                    fournisseur.length > 0 ? (
                        <>
                            <Row>
                                {
                                    fournisseur.map((item, index) => {
                                        if(item.type === 'diamond' || item.type === 'diamond_sougueta'){
                                            return (
                                                <Col sm={6}>
                                                <Card className={`progress-items pb-0 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`} key={index} onClick={() => selectFournisseur({ id: item.id, type: item.type })}>
                                                    <CardHeader className={`pb-4 ${selectType == item.type ? 'bg-light-success' : 'bg-light-info'}`}>
                                                        {/* <Link to={'#'} className="text-dark"> */}
    
                                                            <H5 className="text-center">
                                                                <span className="text-dark fw-bold">{item.name}</span>
                                                            </H5>
                                                        {/* </Link> */}
                                                    </CardHeader>
                                                </Card>
                                            </Col>
                                            )
                                        }
                                    })
                                }
                            </Row>
                            {
                                selectType == 'diamond' ? (

                                    <FormulairesAutresBons id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : selectType == 'diamond_sougueta' ? (

                                    <FormulairesAutresBons id_fournisseur={idFournisseur ?? 0} type={selectType} />

                                ) : (

                                    <Alert color="light-dark" className="text-center">
                                        <H2>Veuillez Selectionner Une Usine</H2>
                                    </Alert>

                                )
                            }


                        </>

                    ) : (
                        <Alert color="info" className="text-center" timeou>
                            <h5 className="text-white text-uppercase text-white fw-bold">Aucun fournisseur enrégistré, Veuillez enrégistrer les fournisseurs</h5>
                        </Alert>
                    )
                }
            </Container>
        </div >
    )
}

export default NouveauAutresBon;